const slideImages = [
  {
    url: 'assets/galeria/turma1_ead/turma1_ead.jpeg',
    caption: 'Parabéns para 1ª Turma EaD FullStacks 🥳 ! ',
  },
  {
    url: 'assets/img/divulgacao/t5_final.jpg',
    caption: 'Parabéns para os novos devs da Turma 5 🥳 ! ',
  },
  {
    url: 'assets/img/divulgacao/turma6.jpg',
    caption: 'Boas-vindas para Turma 6!!!! 🚀',
  },
  // {
  //   url: 'assets/img/divulgacao/t4_final.jpg',
  //   caption: 'Parabéns para os novos devs da Turma 4 🥳 ! ',
  // },
  // {
  //   url: 'assets/img/divulgacao/t3_final.jpg',
  //   caption: 'Parabéns! Novos Devs FullStack Turma 3 🥳',
  // },
  // {
  //   url: 'assets/img/divulgacao/turma2_cc.jpg',
  //   caption: 'Novos Devs FullStack da 2ª Turma! 🥳',
  // },
  // {
  //   url: 'assets/img/divulgacao/turma1.jpg',
  //   caption: 'Entrega de certificados para 1ª Turma do Projeto WebAcademy',
  // },
];

export default slideImages;
